const strings = [
  "adventures.",
  "puzzles.",
  "challenges.",
  "shooters.",
  "simulators.",
  "platformers.",
  "roguelikes.",
  "shaders.",
  "3D art.",
  "video games."
];

export default strings;
